<template>
  <div class="divContainer pageManagePage">
    <div v-if="loading" v-loading="loading" class="fullContainer"></div>
    <div v-else class="pageManagePage__layout">
      <header class="pageManagePage__actionBar">
        <h1 class="pageManagePage__pageTitle">查看页面</h1>
        <div class="pageManagePage__actions">
          <button
            type="button"
            class="pageManagePage__btn pageManagePage__btn--ghost"
            @click="goBack"
          >
            返回
          </button>
          <router-link
            v-check-role
            :to="{ path: '/collection/page/edit/' + id }"
            custom
            v-slot="{ navigate }"
          >
            <button
              type="button"
              class="pageManagePage__btn pageManagePage__btn--primary"
              @click="navigate"
            >
              编辑
            </button>
          </router-link>
          <button
            v-check-role
            type="button"
            class="pageManagePage__btn pageManagePage__btn--danger"
            @click="deletePage"
          >
            删除
          </button>
        </div>
      </header>

      <main class="pageManagePage__main">
        <el-form
          label-position="top"
          size="small"
          :model="ruleForm"
          ref="ruleFormAll"
          disabled
        >
          <el-card class="card">
            <div slot="header">
              <strong class="pageManageCard__title">页面基本信息</strong>
            </div>
            <div class="pageManageFormGrid pageManageFormGrid--basic">
              <el-form-item label="页面名称" prop="pageName">
                <el-input
                  v-model="ruleForm.pageName"
                  class="formItemStyle"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面 Title" prop="pageTitle">
                <el-input
                  v-model="ruleForm.pageTitle"
                  class="formItemStyle"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面类型" prop="pageType">
                <el-select
                  v-model="ruleForm.pageType"
                  class="formItemStyle"
                  popper-class="pageManageDropdown"
                >
                  <el-option
                    v-for="item in pageTypeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-card>

          <el-card class="card">
            <div slot="header">
              <strong class="pageManageCard__title">页面组件</strong>
            </div>

            <p
              v-if="componentList.length > 0"
              class="pageManagePage__intro"
            >
              只读查看；如需修改请点击右上角「编辑」。
            </p>

            <div
              v-if="componentList.length > 0"
              class="pageManageComponentList"
            >
              <el-card
                class="resourcesComponent pageManageComponent"
                v-for="(item, index) in componentList"
                :key="item._key || index"
              >
                <div
                  slot="header"
                  class="cardHeader smallFont pageManageComponent__header"
                >
                  <div class="pageManageComponent__title">
                    <span>{{ componentTypeLabel }}</span>
                    <span class="pageManageComponent__order"
                      >第 {{ index + 1 }} 位</span
                    >
                  </div>
                </div>

                <div class="pageManageComponent__body">
                  <el-form
                    label-position="top"
                    size="small"
                    :model="componentList[index]"
                    ref="ruleForm"
                    disabled
                  >
                    <div class="pageManageFormGrid">
                      <el-form-item label="标题" prop="title">
                        <el-input
                          v-model="componentList[index].title"
                          class="formItemStyle"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="样式" prop="styleId">
                        <el-select
                          v-model="componentList[index].styleId"
                          :ref="'styleSelect' + index"
                          placeholder="选择样式"
                          class="formItemStyle pageManageStyleSelect"
                          popper-class="pageManageDropdown pageManageStyleDropdown"
                          @visible-change="
                            (visible) => onStyleDropdownVisible(visible, index)
                          "
                        >
                          <el-option
                            v-for="style in styleOption"
                            :key="style.id"
                            :label="style.name"
                            :value="style.id"
                          >
                            <div class="pageManageStyleOption">
                              <span
                                class="pageManageStyleOption__name"
                                :title="style.name"
                              >{{ style.name }}</span>
                              <span
                                v-if="style.displayMode"
                                class="pageManageStyleOption__mode"
                              >{{ style.displayMode }}</span>
                            </div>
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <template v-if="ruleForm.pageType === '页面组'">
                        <el-form-item label="选择页面" prop="resourceId">
                          <el-select
                            v-if="!componentList[index].isMultiSelect"
                            :key="'page-single-' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请选择主信息流页面"
                            class="formItemStyle pageManagePageSelect"
                            popper-class="pageManageDropdown pageManagePageDropdown"
                          >
                            <el-option
                              v-for="page in pageOption"
                              :key="page.id"
                              :label="page.name"
                              :value="page.id"
                            >
                              <div class="pageManagePageOption">
                                <span
                                  class="pageManagePageOption__name"
                                  :title="page.name"
                                >{{ page.name }}</span>
                                <span class="pageManagePageOption__type">{{
                                  page.type
                                }}</span>
                              </div>
                            </el-option>
                          </el-select>
                          <el-select
                            v-else
                            :key="'page-multiple-' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请选择主信息流页面（可多选）"
                            class="formItemStyle pageManagePageSelect"
                            multiple
                            popper-class="pageManageDropdown pageManagePageDropdown"
                          >
                            <el-option
                              v-for="page in pageOption"
                              :key="page.id + '-multi'"
                              :label="page.name"
                              :value="page.id"
                            >
                              <div class="pageManagePageOption">
                                <span
                                  class="pageManagePageOption__name"
                                  :title="page.name"
                                >{{ page.name }}</span>
                                <span class="pageManagePageOption__type">{{
                                  page.type
                                }}</span>
                              </div>
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </template>

                      <template v-else>
                        <el-form-item label="分类类型">
                          <el-select
                            v-model="componentList[index].categoryTypeKey"
                            placeholder="壁纸 / AI / 通用"
                            class="formItemStyle"
                            popper-class="pageManageDropdown"
                          >
                            <el-option
                              v-for="typeItem in feedTypeOptions"
                              :key="typeItem.categoryType"
                              :label="typeItem.name"
                              :value="typeItem.categoryType"
                            ></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="选择分类" prop="resourceId">
                          <el-select
                            v-if="!componentList[index].isMultiSelect"
                            :key="'category-single-' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请先选分类类型"
                            class="formItemStyle"
                            popper-class="pageManageDropdown"
                          >
                            <el-option
                              v-for="cat in categoriesForComponent(index)"
                              :key="cat.id"
                              :label="cat.name"
                              :value="cat.id"
                            ></el-option>
                          </el-select>
                          <el-select
                            v-else
                            :key="'category-multiple-' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请先选分类类型（可多选）"
                            class="formItemStyle"
                            multiple
                            popper-class="pageManageDropdown"
                          >
                            <el-option
                              v-for="cat in categoriesForComponent(index)"
                              :key="cat.id + '-multi'"
                              :label="cat.name"
                              :value="cat.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="展示数量" prop="showAmount">
                          <el-input
                            v-model="componentList[index].showAmount"
                            type="number"
                            class="formItemStyle"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
            <el-empty
              v-else
              description="暂无组件"
              :image-size="100"
            ></el-empty>
          </el-card>
        </el-form>
      </main>
    </div>
  </div>
</template>

<script>
import { deletepage, getInfoById, queryType } from '../../../api/pageManage'
import {
  getAllStyle,
  getCategoryAll,
  getClassifyResourceType,
} from '../../../api/comment'
import { getAllPage } from '../../../api/dataManage'
import {
  FEED_TYPE_OPTIONS,
  filterCategoriesByType,
  filterFeedCategories,
  mergeBoundCategoriesForComponent,
  resolveCategoryTypeKey,
  resolveFeedTypeOptionsFromApi,
  sortFeedTypeOptions,
} from './pageManageCategoryHelper'
import './pageManageSurfaces.css'

export default {
  name: 'info',
  data() {
    return {
      id: '',
      ruleForm: {
        pageName: '',
        pageType: '',
        pageTitle: '',
      },
      componentList: [],
      loading: false,
      pageTypeOptions: [],
      styleOption: [],
      pageOption: [],
      categoryOption: [],
      feedTypeOptions: sortFeedTypeOptions(FEED_TYPE_OPTIONS.slice()),
    }
  },
  computed: {
    componentTypeLabel() {
      return this.ruleForm.pageType === '页面组' ? '页面组件' : '信息流组件'
    },
  },
  created() {
    this.loadFeedTypeOptions()
    this.getData()
    this.getPageType()
    this.getAllStyleOption()
  },
  methods: {
    onStyleDropdownVisible(visible, index) {
      if (!visible) {
        return
      }
      this.$nextTick(() => {
        const ref = this.$refs['styleSelect' + index]
        const select = Array.isArray(ref) ? ref[0] : ref
        if (!select || !select.$refs.popper) {
          return
        }
        const width = Math.ceil(select.$el.getBoundingClientRect().width)
        const popperEl = select.$refs.popper.$el
        popperEl.style.minWidth = `${width}px`
        popperEl.style.width = `${width}px`
      })
    },
    categoriesForComponent(index) {
      const component = this.componentList[index]
      const pool = mergeBoundCategoriesForComponent(this.categoryOption, component)
      return filterCategoriesByType(
        pool,
        component && component.categoryTypeKey
      )
    },
    loadFeedTypeOptions() {
      getClassifyResourceType()
        .then((res) => {
          this.feedTypeOptions = resolveFeedTypeOptionsFromApi(res)
        })
        .catch(() => {
          this.feedTypeOptions = sortFeedTypeOptions(FEED_TYPE_OPTIONS.slice())
        })
    },
    syncComponentCategoryTypes() {
      this.componentList.forEach((component, index) => {
        const typeKey = resolveCategoryTypeKey(
          this.categoryOption,
          component.resourceId,
          component.categoryTypeKey
        )
        this.$set(this.componentList[index], 'categoryTypeKey', typeKey)
        if (!component._key) {
          this.$set(
            this.componentList[index],
            '_key',
            'legacy-' + index + '-' + component.sequence
          )
        }
      })
    },
    applyComponentDisplayMode(index) {
      const component = this.componentList[index]
      if (!component) {
        return
      }
      const styleId = component.styleId
      const resourceId = component.resourceId
      const singleValue = Array.isArray(resourceId)
        ? resourceId[0] !== null &&
          resourceId[0] !== undefined &&
          resourceId[0] !== ''
          ? resourceId[0]
          : ''
        : resourceId

      // 后端下发的组件对象未声明 isMultiSelect，必须用 $set 才能触发 Vue 2 响应式
      if (styleId || styleId === 0) {
        let matched = false
        this.styleOption.forEach((style) => {
          if (style.id === styleId) {
            matched = true
            if (style.displayMode === '资源展示') {
              this.$set(component, 'resourceId', singleValue)
              this.$set(component, 'isMultiSelect', false)
            } else {
              this.$set(component, 'isMultiSelect', true)
            }
          }
        })
        if (!matched) {
          this.$set(component, 'isMultiSelect', Array.isArray(resourceId))
        }
      } else {
        this.$set(component, 'isMultiSelect', Array.isArray(resourceId))
      }
    },
    applyAllComponentDisplayModes() {
      this.componentList.forEach((component, index) => {
        this.applyComponentDisplayMode(index)
      })
    },
    getData() {
      this.loading = true
      getInfoById({ id: this.$route.params.id })
        .then((res) => {
          if (!res.success) {
            return Promise.resolve()
          }
          this.id = res.data.id
          this.ruleForm.pageName = res.data.name
          this.ruleForm.pageType = res.data.type
          this.ruleForm.pageTitle = res.data.title
          this.componentList = res.data.resourceComponentVOList || []
          return this.getResourceAllOption().then(() => {
            this.applyAllComponentDisplayModes()
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPageType() {
      queryType().then((res) => {
        if (res.success) {
          this.pageTypeOptions = this.$sortSelect(res.data || [])
        }
      })
    },
    getAllStyleOption() {
      return getAllStyle().then((res) => {
        if (res.success) {
          this.styleOption = this.$sortSelect(res.data)
        }
        return res
      })
    },
    getResourceAllOption() {
      const styleReady = this.styleOption.length
        ? Promise.resolve()
        : this.getAllStyleOption()
      return styleReady.then(() => {
        if (this.ruleForm.pageType === '页面组') {
          return getAllPage().then((res) => {
            if (res.success) {
              this.pageOption = this.$sortSelect(res.data)
            }
          })
        }
        return getCategoryAll().then((res) => {
          if (res.success) {
            this.categoryOption = this.$sortSelect(filterFeedCategories(res.data))
            this.syncComponentCategoryTypes()
          }
        })
      })
    },
    goBack() {
      this.$router.push('/collection/page/list')
    },
    deletePage() {
      if (!this.id) {
        this.$message.warning('页面 ID 缺失，无法删除')
        return
      }
      this.$confirm('此操作将删除该页面，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => deletepage({ id: this.id }))
        .then((res) => {
          if (res && res.success) {
            this.$message.success('删除成功')
            this.goBack()
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped>
.divContainer {
  height: 100%;
}

.fullContainer {
  width: 100%;
  height: 100%;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.smallFont {
  font-size: 12px;
}
</style>
